module.exports = __webpack_public_path__ + "static/fonts/AmwayIcons.4a51a7d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/self-diagnosis/font/AmwayIcons.woff?5v2gxx
// module id = Vp/d
// module chunks = 0